<div fxLayout="column" fxLayoutAlign="center start">
  <div *ngIf="getFilterOptions(node.type) as options" fxFill fxLayout="row" fxLayoutAlign="space-between center">
    <app-mat-simple-select
      fxFlex="50"
      label="Select Filter"
      [disabled]="!options.length"
      [selectItems]="options"
      [(ngModel)]="filterSelect"
    ></app-mat-simple-select>

    <button mat-raised-button [disabled]="!filterSelect" (click)="onAddFilter()">Add Filter</button>
  </div>

  <div
    *ngFor="let filterGroup of eventFlowFilterGroups; let i = index"
    fxFill
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <app-mat-multiselect
      [label]="UNIQUE_FILTER_LABELS[filterGroup.get('key')?.value] + ' *'"
      [allowCustomValue]="true"
      [required]="true"
      [autoCompleteValues]="getSelectValues(filterGroup.get('key')?.value)"
      [formControl]="$any(filterGroup.get('values'))"
    ></app-mat-multiselect>

    <button mat-icon-button (click)="onRemoveFilter(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
